var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfluence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "72px",
    viewBox: "0 0 69 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Topics-Menu---rev9",
    transform: "translate(-276.000000, -572.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(276.000000, 572.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,35.5 C39,37.9851133 36.9849198,40 34.4995678,40 C32.0150802,40 30,37.9851133 30,35.5 C30,33.0148867 32.0150802,31 34.4995678,31 C36.9849198,31 39,33.0148867 39,35.5",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,35.5 C45,41.2989497 40.2989497,46 34.5,46 C28.7010503,46 24,41.2989497 24,35.5 C24,29.7010503 28.7010503,25 34.5,25 C40.2989497,25 45,29.7010503 45,35.5 Z",
    id: "Stroke-3",
    stroke: "#FFFFFF",
    strokeWidth: 4.786
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,36 C52,45.3888393 44.3890279,53 35.0004212,53 C25.6109721,53 18,45.3888393 18,36 C18,26.6111607 25.6109721,19 35.0004212,19 C44.3890279,19 52,26.6111607 52,36 Z",
    id: "Stroke-5",
    stroke: "#FFFFFF",
    strokeWidth: 2.6,
    opacity: 0.765530541
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,36 C58,48.7027245 47.7027245,59 35,59 C22.2972755,59 12,48.7027245 12,36 C12,23.2972755 22.2972755,13 35,13 C47.7027245,13 58,23.2972755 58,36 Z",
    id: "Stroke-7",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    opacity: 0.534746443
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,36 C63,51.4640988 50.4640988,64 35,64 C19.5367385,64 7,51.4640988 7,36 C7,20.5359012 19.5367385,8 35,8 C50.4640988,8 63,20.5359012 63,36 Z",
    id: "Stroke-9",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    opacity: 0.345893497
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,36 C68,54.2258539 53.2252044,69 35.0004184,69 C16.7747956,69 2,54.2258539 2,36 C2,17.7741461 16.7747956,3 35.0004184,3 C53.2252044,3 68,17.7741461 68,36 Z",
    id: "Stroke-11",
    stroke: "#FFFFFF",
    strokeWidth: 1.25,
    opacity: 0.199816023
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3955226,60 L23.6044774,60 C22.7186633,60 22,59.2947624 22,58.4236356 L22,14.5755308 C22,13.7052376 22.7186633,13 23.6044774,13 L46.3955226,13 C47.2813367,13 48,13.7052376 48,14.5755308 L47.9991515,58.4236356 C47.9991515,59.2947624 47.2813367,60 46.3955226,60",
    id: "Fill-13",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4930529,59 L24.5077957,59 C23.675411,59 23,58.3366401 23,57.518079 L23,15.481921 C23,14.6633599 23.675411,14 24.5077957,14 L45.4930529,14 C46.3254375,14 47,14.6633599 47,15.481921 L47,57.518079 C47,58.3366401 46.3254375,59 45.4930529,59 Z",
    id: "Stroke-15",
    stroke: "#434345",
    strokeWidth: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,16.5 C35,16.7758359 34.7758359,17 34.5,17 C34.2234043,17 34,16.7758359 34,16.5 C34,16.2241641 34.2234043,16 34.5,16 C34.7758359,16 35,16.2241641 35,16.5",
    id: "Fill-17",
    fill: "#3F3F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.791,16.5 C33.791,16.661 33.661,16.791 33.5,16.791 C33.339,16.791 33.209,16.661 33.209,16.5 C33.209,16.339 33.339,16.209 33.5,16.209 C33.661,16.209 33.791,16.339 33.791,16.5",
    id: "Fill-19",
    fill: "#3F3F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3657062,4 L29.6342938,4 C29.2836994,4 29,3.71630062 29,3.36570623 L29,0.634293774 C29,0.283699375 29.2836994,0 29.6342938,0 L32.3657062,0 C32.7163006,0 33,0.283699375 33,0.634293774 L33,3.36570623 C33,3.71630062 32.7163006,4 32.3657062,4",
    id: "Fill-21",
    fill: "#F3783E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3657062,72 L54.6342938,72 C54.2836994,72 54,71.7163006 54,71.3657062 L54,68.6342938 C54,68.2836994 54.2836994,68 54.6342938,68 L57.3657062,68 C57.7163006,68 58,68.2836994 58,68.6342938 L58,71.3657062 C58,71.7163006 57.7163006,72 57.3657062,72",
    id: "Fill-23",
    fill: "#F59184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3657062,49 L28.6342938,49 C28.2836994,49 28,48.7163006 28,48.3657062 L28,45.6342938 C28,45.2836994 28.2836994,45 28.6342938,45 L31.3657062,45 C31.7163006,45 32,45.2836994 32,45.6342938 L32,48.3657062 C32,48.7163006 31.7163006,49 31.3657062,49",
    id: "Fill-25",
    fill: "#EE403A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3657062,32 L31.6342938,32 C31.2836994,32 31,31.7163006 31,31.3657062 L31,28.6342938 C31,28.2836994 31.2836994,28 31.6342938,28 L34.3657062,28 C34.7163006,28 35,28.2836994 35,28.6342938 L35,31.3657062 C35,31.7163006 34.7163006,32 34.3657062,32",
    id: "Fill-27",
    fill: "#5F7455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3657062,62 L13.6342938,62 C13.2836994,62 13,61.7163006 13,61.3657062 L13,58.6342938 C13,58.2836994 13.2836994,58 13.6342938,58 L16.3657062,58 C16.7163006,58 17,58.2836994 17,58.6342938 L17,61.3657062 C17,61.7163006 16.7163006,62 16.3657062,62",
    id: "Fill-29",
    fill: "#A2AF58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3657062,8 L45.6342938,8 C45.2836994,8 45,7.71630062 45,7.36570623 L45,4.63429377 C45,4.28369938 45.2836994,4 45.6342938,4 L48.3657062,4 C48.7163006,4 49,4.28369938 49,4.63429377 L49,7.36570623 C49,7.71630062 48.7163006,8 48.3657062,8",
    id: "Fill-31",
    fill: "#9080A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3657062,25 L46.6342938,25 C46.2836994,25 46,24.7163006 46,24.3657062 L46,21.6342938 C46,21.2836994 46.2836994,21 46.6342938,21 L49.3657062,21 C49.7163006,21 50,21.2836994 50,21.6342938 L50,24.3657062 C50,24.7163006 49.7163006,25 49.3657062,25",
    id: "Fill-33",
    fill: "#5D76A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3657062,13 L7.63429377,13 C7.28369938,13 7,12.7163006 7,12.3657062 L7,9.63429377 C7,9.28369938 7.28369938,9 7.63429377,9 L10.3657062,9 C10.7163006,9 11,9.28369938 11,9.63429377 L11,12.3657062 C11,12.7163006 10.7163006,13 10.3657062,13",
    id: "Fill-35",
    fill: "#3AA1C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3657062,5 L59.6342938,5 C59.2836994,5 59,4.71630062 59,4.36570623 L59,1.63429377 C59,1.28369938 59.2836994,1 59.6342938,1 L62.3657062,1 C62.7163006,1 63,1.28369938 63,1.63429377 L63,4.36570623 C63,4.71630062 62.7163006,5 62.3657062,5",
    id: "Fill-37",
    fill: "#FBD2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3657062,24 L57.6342938,24 C57.2836994,24 57,23.7163006 57,23.3657062 L57,20.6342938 C57,20.2836994 57.2836994,20 57.6342938,20 L60.3657062,20 C60.7163006,20 61,20.2836994 61,20.6342938 L61,23.3657062 C61,23.7163006 60.7163006,24 60.3657062,24",
    id: "Fill-39",
    fill: "#7E5B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3657062,36 L41.6342938,36 C41.2836994,36 41,35.7163006 41,35.3657062 L41,32.6342938 C41,32.2836994 41.2836994,32 41.6342938,32 L44.3657062,32 C44.7163006,32 45,32.2836994 45,32.6342938 L45,35.3657062 C45,35.7163006 44.7163006,36 44.3657062,36",
    id: "Fill-41",
    fill: "#B25F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3657062,31 L11.6342938,31 C11.2836994,31 11,30.7163006 11,30.3657062 L11,27.6342938 C11,27.2836994 11.2836994,27 11.6342938,27 L14.3657062,27 C14.7163006,27 15,27.2836994 15,27.6342938 L15,30.3657062 C15,30.7163006 14.7163006,31 14.3657062,31",
    id: "Fill-43",
    fill: "#A43157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3657062,15 L25.6342938,15 C25.2836994,15 25,14.7163006 25,14.3657062 L25,11.6342938 C25,11.2836994 25.2836994,11 25.6342938,11 L28.3657062,11 C28.7163006,11 29,11.2836994 29,11.6342938 L29,14.3657062 C29,14.7163006 28.7163006,15 28.3657062,15",
    id: "Fill-45",
    fill: "#EA246E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3657062,42 L34.6342938,42 C34.2836994,42 34,41.7163006 34,41.3657062 L34,38.6342938 C34,38.2836994 34.2836994,38 34.6342938,38 L37.3657062,38 C37.7163006,38 38,38.2836994 38,38.6342938 L38,41.3657062 C38,41.7163006 37.7163006,42 37.3657062,42",
    id: "Fill-47",
    fill: "#DDCF21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36570623,42 L0.634293774,42 C0.283699375,42 0,41.7163006 0,41.3657062 L0,38.6342938 C0,38.2836994 0.283699375,38 0.634293774,38 L3.36570623,38 C3.71630062,38 4,38.2836994 4,38.6342938 L4,41.3657062 C4,41.7163006 3.71630062,42 3.36570623,42",
    id: "Fill-49",
    fill: "#3E7778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3657062,54 L53.6342938,54 C53.2836994,54 53,53.7163006 53,53.3657062 L53,50.6342938 C53,50.2836994 53.2836994,50 53.6342938,50 L56.3657062,50 C56.7163006,50 57,50.2836994 57,50.6342938 L57,53.3657062 C57,53.7163006 56.7163006,54 56.3657062,54",
    id: "Fill-51",
    fill: "#FABB70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3657062,62 L37.6342938,62 C37.2836994,62 37,61.7163006 37,61.3657062 L37,58.6342938 C37,58.2836994 37.2836994,58 37.6342938,58 L40.3657062,58 C40.7163006,58 41,58.2836994 41,58.6342938 L41,61.3657062 C41,61.7163006 40.7163006,62 40.3657062,62",
    id: "Fill-53",
    fill: "#EE6D89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3657062,50 L9.63429377,50 C9.28369938,50 9,49.7163006 9,49.3657062 L9,46.6342938 C9,46.2836994 9.28369938,46 9.63429377,46 L12.3657062,46 C12.7163006,46 13,46.2836994 13,46.6342938 L13,49.3657062 C13,49.7163006 12.7163006,50 12.3657062,50",
    id: "Fill-55",
    fill: "#F9AC1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3657062,49 L39.6342938,49 C39.2836994,49 39,48.7163006 39,48.3657062 L39,45.6342938 C39,45.2836994 39.2836994,45 39.6342938,45 L42.3657062,45 C42.7163006,45 43,45.2836994 43,45.6342938 L43,48.3657062 C43,48.7163006 42.7163006,49 42.3657062,49",
    id: "Fill-57",
    fill: "#F7BABA"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluence);
export default __webpack_public_path__ + "static/media/influence.a06a20c30f8b92afc55855b851427bfc.svg";
export { ForwardRef as ReactComponent };